/*!
 * Empress 1908 Gin - Big Thirst Headless Loader
 *
 * Install this stable file once on empressgin.com. It fetches the config with
 * a fresh query string so future config and engine changes stay cache-safe.
 */

(function () {
  'use strict';

  if (window.__BT_EMPRESS_LOADER_LOADED) return;
  window.__BT_EMPRESS_LOADER_LOADED = true;

  var DEFAULT_CONFIG_SRC = 'https://empress-1908-gin.myshopify.com/cdn/shop/files/empress-config.js';
  var configSrc = window.__BT_EMPRESS_CONFIG_SRC || DEFAULT_CONFIG_SRC;
  var configVersion = window.__BT_EMPRESS_CONFIG_VERSION || String(Date.now());
  var separator = configSrc.indexOf('?') === -1 ? '?' : '&';
  var head = document.head || document.documentElement;
  var script = document.createElement('script');

  script.src = configSrc + separator + 'v=' + encodeURIComponent(configVersion);
  script.async = false;
  script.setAttribute('data-bt-empress-config', 'true');
  head.appendChild(script);
})();
